export default __webpack_public_path__ + "static/media/logo_oko.690c5bd4.png";